var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h12ZM7.995 3.005c.55 0 1 .45 1 .999v5.584l1.29-1.288a1.002 1.002 0 0 1 1.42 1.419l-3 2.996a1.015 1.015 0 0 1-1.42 0l-3-2.997A1.002 1.002 0 0 1 5.705 8.3l1.29 1.29V4.013c0-.55.45-1.009 1-1.009ZM14 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM5 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM2 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringData);
export default __webpack_public_path__ + "static/media/bring-data.2ddbf028f52f52a1f46b79df17aedafd.svg";
export { ForwardRef as ReactComponent };